<template>
    <div>
        <div class="taker-name">
            <strong class="info-name">
                {{displayChannelName}}
            </strong>
            <div
                v-if="channelIsOn"
                class="icon-taker-ready">
                <span class="material-icons icon-ready">
                    arrow_right
                </span>
                <p style="margin-bottom: 0">ON</p>
            </div>
            <div
                v-else
                class="icon-taker-stop">
                <span class="material-icons icon-stop" style="font-size: 15px;">
                    stop
                </span>
                <p style="margin-bottom: 0">Off</p>
            </div>
        </div>
        <p
            v-if="!channelIsOn"
            class="time-start-end"
        >
            <span v-if="hasSchedulings">
                START : {{ startDateTimeUtc | moment("HH:mm") }}
                <span class="time-details">(UTC 0)</span> - {{ startDateTimeLocal | moment("HH:mm") }}
                <span class="time-details">(Local time)</span>
            </span>
            <span v-else>
                START : {{startTimeUtc}}
                <span class="time-details">(UTC 0)</span> - {{startTimeLocal}}
                <span class="time-details">(Local time)</span>
            </span>
        </p>
        <p
            v-else
            class="time-start-end"
        >
            END : {{ endDateTimeUtc | moment("HH:mm") }}
            <span class="time-details">(UTC 0)</span> - {{ endDateTimeLocal | moment("HH:mm") }}
            <span class="time-details">(Local time)</span>
        </p>
        <div class="display">
            <div v-if="channelSupervision.takers.length === 0" class="takers-style">
                There are no takers for this channel
            </div>
            <div
                v-else
                v-for="taker in channelSupervision.takers"
                :key="taker.uid"
                :label="taker.name"
                :value="taker"
                class="monitoring-takers"
                @click.stop="openChannelConfiguration(taker)"
            >
                <channel-overview-takers
                    :channel-is-on="channelIsOn"
                    :taker="taker"
                ></channel-overview-takers>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import ChannelOverviewTakers from './channel-overview-takers.vue';
export default {

    name: 'channel-overview-card',

    components:{
        ChannelOverviewTakers,
        NsLoader,
    },

    props:{
        schedulings:{
            type: Array,
            required: true
        },
        channelSupervision:{
            type: Object,
            required: true
        },
    },

    data () {
        return {
        };
    },
    computed:{
        channelIsOn(){
            return this.channelSupervision.channel.status === 'RUNNING';
        },
        hasSchedulings(){
            if (this.schedulings.length > 0){
                return true;
            }
            return false;
        },
        nextEndingScheduling(){
            if(this.hasSchedulings){
                return this.schedulings[0];
            }
            return null;
        },

        startDateTimeUtc (){
            return  moment.utc(this.nextEndingScheduling.start_date);
        },
        startDateTimeLocal (){
            return  moment.utc(this.nextEndingScheduling.start_date).local();
        },
        endDateTimeUtc (){
            return  moment.utc(this.nextEndingScheduling.end_date);
        },
        endDateTimeLocal (){
            return  moment.utc(this.nextEndingScheduling.end_date).local();
        },
        startTimeUtc (){
            return  moment.utc(this.channelSupervision.channel.default_start_time, 'HH:mm').format('HH:mm');
        },
        startTimeLocal (){
            return  moment.utc(this.channelSupervision.channel.default_start_time, 'HH:mm').local().format('HH:mm');
        },
        displayChannelName(){
            return this.channelSupervision.channel_display_name.toUpperCase();
        }
    },
    methods:{
        openChannelConfiguration(taker){
            this.$emit('openChannelConfiguration', {channel:this.channelSupervision, tab:'configuration', taker:taker});
        }
    }
};
</script>

<style lang="css" scoped>
.display{
    display: flex;
    flex-wrap: wrap;
}
.monitoring-takers{
    background-color: #131417;
    border-radius: 2px;
    margin-bottom: 10px;
    padding: 8px;
    max-width: 173px;
    justify-content: center;
    margin-right: 10px;
}
.taker-name{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 21px;
    line-height: 25px;
}
.info-name{
    font-size: 21px;
    line-height: 25px;
    font-weight: 600;
}

.icon-ready{
    color: #222222;
    background-color: #31BD9B;
    border-radius: 50%;
    margin-right: 5px;
    align-items: center;
    justify-content: center;
    display: flex;
}

.icon-stop{
    color: #222222;
    background-color: #F56C6C;
    border-radius: 50%;
    margin-right: 5px;
    height: 21px;    
    width: 21px;
    align-items: center;
    justify-content: center;
    display: flex;
}

.icon-taker-ready{
    font-weight: 500;
    color: #31BD9B;
    display: flex;
}

.icon-taker-stop{
    display: flex;
    font-weight: 500;
    color: #F56C6C;
}

.time-start-end{
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
    margin: 10px 0 15px 0;
    color: white;
}

.time-details{
    color: grey;
}
</style>




// WEBPACK FOOTER //
// src/components/page/ChannelsOverview/channel-overview-card.vue